import { Endpoint } from "../config";

export type StaffEndpointType =
  | "staffMembers"
  | "createStaff"
  | "updateStaff"
  | "deleteStaff"
  | "getStaffById"
  | "updateStaffStatus"
  | "resendInvite";

export const staffEndpoints: Record<StaffEndpointType, Endpoint> = {
  staffMembers: {
    url: "tenant-staff/",
  },
  createStaff: {
    url: "tenant-staff/",
  },
  updateStaff: {
    url: "tenant-staff/[id]/",
  },
  updateStaffStatus: {
    url: "tenant-staff/[id]/",
  },
  deleteStaff: {
    url: "tenant-staff/[id]/",
  },
  getStaffById: {
    url: "tenant-staff/[id]/",
  },
  resendInvite:{
     url: "reinvite/",
  }
};
